export default "__VITE_ASSET__Bdms6YDt__"